// extracted by mini-css-extract-plugin
export default {"selected":"b43b76eca7","un":"_4972ac80c2"};